import { runCookieBannerExperiment } from "../content/cookie-banner";
import { cookieBannerExperimentStorageKey, experimentDomain } from "./cookie-banner.types";
import { executeFunction } from "./script-injector";
import { cookieBannerEventNames } from "../shared";
import { Prefs } from "~/alias/prefs";
import { License } from "~/picreplacement/check";
import LogoIcon from "../content/icons/logo.js";
async function navigationListener(details) {
    const { tabId, frameId, url } = details;
    if (await License.isActiveLicense()) {
        return;
    }
    if (frameId !== 0) {
        return;
    }
    if (!url.startsWith(experimentDomain)) {
        return;
    }
    const browserLanguage = browser.i18n.getUILanguage();
    if (!browserLanguage.toLowerCase().startsWith("en")) {
        return;
    }
    browser.webNavigation.onCommitted.removeListener(navigationListener);
    void Prefs.set(cookieBannerExperimentStorageKey, true);
    try {
        void executeFunction(tabId, frameId, runCookieBannerExperiment, [
            cookieBannerEventNames.cpmMessageDetected,
            cookieBannerEventNames.buttonInjected,
            cookieBannerEventNames.buttonClicked,
            LogoIcon,
        ]);
    }
    catch (_) {
    }
}
export function start() {
    if (Prefs.get(cookieBannerExperimentStorageKey) === true) {
        return;
    }
    browser.webNavigation.onCommitted.addListener(navigationListener);
}
